'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowShuffle = function TiArrowShuffle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.7 15h5.8c1.2 0 2.3 0.7 3.1 1.7 0.5-1 1.2-2 2-2.8-1.4-1.4-3.1-2.2-5.1-2.2h-5.8c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7z m12.8 5.2c0.9-2.8 3.7-5.2 6.1-5.2h3l-2.1 2.2c-0.7 0.6-0.7 1.7 0 2.3 0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5l6.2-6.2-6.2-6.1c-0.6-0.7-1.7-0.7-2.3 0s-0.7 1.7 0 2.3l2.1 2.2h-3c-3.8 0-7.9 3.2-9.3 7.4l-0.8 2.4c-1 3.2-3.4 5.2-4.7 5.2h-4.1c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h4.1c3.1 0 6.5-3.2 7.9-7.5l0.8-2.3z m7 2c-0.7 0.6-0.7 1.7 0 2.3l2.1 2.2h-3.9c-2.1 0-3.9-1.5-4.5-3.5-0.4 1.2-1 2.5-1.8 3.6 1.5 1.9 3.8 3.2 6.3 3.2h3.9l-2.1 2.2c-0.7 0.6-0.7 1.7 0 2.3 0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5l6.2-6.2-6.2-6.1c-0.6-0.7-1.7-0.7-2.3 0z' })
        )
    );
};

exports.default = TiArrowShuffle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-shuffle.js
// module id = 1967
// module chunks = 0